import merge from 'lodash.merge'
import sendClickunderStats from '@resources/js/components/clickunderStats'
import {
	PROMOTION_TYPES,
	DEFAULT_PROMOTION_ACTIONS,
} from '@resources/js/components/promotion/config'

const beforeActionCb = ({ type, partnerUrl, additionalParams }) => {
	sendClickunderStats({ type, partnerUrl, additionalParams })
}

const promotion = (customPromotionActions = {}) => {
	const promotionActions = merge(DEFAULT_PROMOTION_ACTIONS, customPromotionActions)

	Object.entries(promotionActions).forEach(([actionType, action]) => {
		if (!action.active) return

		const actionPartnerUrl = PROMOTION_TYPES[action.type].generateLink({
			type: actionType,
		})

		action.init({
			partnerUrl: actionPartnerUrl,
			type: action.type,
			beforeActionCallback: ({
				type = actionType,
				partnerUrl = actionPartnerUrl,
				additionalParams,
			} = {}) => {
				beforeActionCb({ type, partnerUrl, additionalParams })
			},
		})
	})
}

export default promotion
